import React, { useContext, useEffect, useRef, useState } from "react";
import {
  IonContent,
  IonItem,
  IonToolbar,
  IonButton,
  IonItemDivider,
  IonRow,
  IonCol,
  IonIcon,
  IonList,
  IonPopover,
  IonModal,
  IonText,
  IonImg,
  IonMenu,
  IonHeader,
  IonTitle,
  IonButtons,
  IonMenuButton,
  IonMenuToggle,
  IonListHeader,
  IonLabel,
  IonFab,
  IonFabButton,
  IonFabList,
  useIonAlert,
} from "@ionic/react";
import { Link, NavLink as BaseNavLink, NavLink, useHistory, useLocation } from "react-router-dom";
import "./Userpage.css";
import "./Home.css";
import "./Login.css";
import { Camera, CameraResultType, CameraSource } from '@capacitor/camera';


import { menuController } from "@ionic/core/components";

import { arrowDown, arrowForward, chevronDownOutline, chevronForwardOutline, menu, menuOutline, person, personCircle, personCircleOutline, personOutline } from "ionicons/icons";
import { Modal } from "react-bootstrap";
import { Capacitor } from "@capacitor/core";
import { BudhaImg, logo, usermanualPdf } from "../theme/imagePath";
import { AppContext } from "../components/AppContext";
import { Plugins } from '@capacitor/core';
import Authservice from "../Services/user.service";
import UserService from "../Services/auth.service";


interface Props {
  User: string;
  Role: string;
  Name: string;
}
const HeadFoot: React.FC<Props> = (props) => {
  const modal = useRef<HTMLIonModalElement>(null);
  const [log, setLog] = useState(false);
  const history = useHistory();
  const { Storage } = Plugins;
  // var userdata = sessionStorage.getItem("UserData")
  // var uFlag = sessionStorage.getItem("uFlag")
  //var token = sessionStorage.getItem("token")
  const { token } = useContext(AppContext)!;
  const { uFlag } = useContext(AppContext)!;
  const { userdata } = useContext(AppContext)!;
  const { userid } = useContext(AppContext)!;
  const { setUserData } = useContext(AppContext)!;
  const { setUFlag } = useContext(AppContext)!;
  const { setToken } = useContext(AppContext)!;
  const popover = useRef<HTMLIonPopoverElement>(null);
  const popover1 = useRef<HTMLIonPopoverElement>(null);
  const popover2 = useRef<HTMLIonPopoverElement>(null);
  const [popoverOpen, setPopoverOpen] = useState(false);
  const [popoverOpen1, setPopoverOpen1] = useState(false);
  const [popoverOpen2, setPopoverOpen2] = useState(false);
  const [modalopen, setModalopen] = useState(false);
  const [Alert] = useIonAlert();

  const [showVolunteerSubmenu, setShowVolunteerSubmenu] = useState(false);

  const [showSubmenu, setShowSubmenu] = useState(false);

  const toggleSubmenu = () => {
    setShowSubmenu(!showSubmenu);
  };



  function openPopover(e: any) {
    popover.current!.event = e;
    setPopoverOpen(true);
  }

  const openPopover1 = (e: any) => {
    popover1.current!.event = e;
    setPopoverOpen1(true);
  };

  const openPopover2 = (e: any) => {
    popover2.current!.event = e;
    setPopoverOpen2(true);
  };
  const local: any = useLocation()
  var assign: any;
  const logout = async () => {
    UserService.logout(token).then(async (response) => {
      // Cart();
      if (response.data == "Logout successful") {
        try {
          await Storage.clear();
          console.log('Cache cleared successfully.');
        } catch (error) {
          console.error('Error clearing cache:', error);
        }

        setModalopen(false);
        sessionStorage.clear()
        setUserData(null);
        setUFlag(null)
        setToken(null)
        window.location.hash = "/login";
        if (Capacitor.getPlatform() == "ios") {
          window.location.href = "/login"
        }
        window.location.reload();
      } else {
        setModalopen(false);
        Alert("something went wrong. Please try again")
      }

    })
      .catch((error) => {
        console.log(error, "error")
        Alert("something went wrong. Please try again")


      });


  };
  const handleVolunteerClick = (e: any) => {
    e.preventDefault(); // Prevent navigation on click
    setShowVolunteerSubmenu((prev) => !prev); // Toggle submenu visibility
  };

  const check = () => {
    console.log(token, "token")
    if (token == null || uFlag == "false") {
      history.push('/login')
    }
  }

  const pathname = props.Name;
  const [commanName, setCommanName] = useState("");
  const [pageName, setPageName] = useState("");

  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [userId, setUserId]: any = useState(sessionStorage.getItem("UserId"));
  const [appVersion, setAppVersion] = useState("");

  // Function to update the screen width when the window is resized
  const updateScreenWidth = () => {
    setScreenWidth(window.innerWidth);
  };

  useEffect(() => {
    if (pathname) {
      const [newCommanName, newPageName] = pathname.split(",");
      setCommanName(newCommanName);
      setPageName(newPageName);
    } else {
      setCommanName("");
      setPageName("");
    }

    Authservice.getAppConfigs(token, "DEF", userid).then((response) => {
      console.log(response.data)
      setAppVersion(response.data.filter((e: any) => e.name === "AppVersion")[0].value)
    })
      .catch((error: any) => {
        console.log(error + "mobErr")
      });

    window.addEventListener('resize', updateScreenWidth);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener('resize', updateScreenWidth);
    };
  }, [pathname]);

  // useEffect(() => {
  //   check()
  //   var assign: any;
  //   console.log(userdata);
  //   if (assign !== null && assign !== undefined) {
  //     clearInterval(assign);
  //     assign = setInterval(() => {
  //       console.log("counter for 3 seconds");
  //       clearInterval(assign);
  //       sessionStorage.clear();
  //       window.location.hash = "login";
  //     }, 60000000);
  //   } else {
  //     assign = setInterval(() => {
  //       console.log("counter for 3 seconds");
  //       clearInterval(assign);
  //       sessionStorage.clear();
  //       window.location.hash = "login";
  //     }, 60000000);
  //   }
  //   console.log("___________", local.pathname)
  // }, []);

  const tempMgmt = () => {
    if (local.pathname === "/tempadmin") {
      window.location.reload()

    } else {

      history.push("/tempadmin")
    }
  }
  const matMgmt = () => {
    if (local.pathname === "/vendormaterials") {
      window.location.reload()

    } else {

      history.push("/vendormaterials")
    }
  }

  const [isPoojaVisible, setIsPoojaVisible] = useState(false);
  const [isGraVisible, setIsGraisible] = useState(false);
  const [isProjVisible, setIsProjisible] = useState(false);

  const isHome = local.pathname === '/home' || local.pathname === '/';
  const mobile = screenWidth <= 1000;
  const displayHeadBackgroundImg = isHome && screenWidth <= 1000;

  const [isPopoverOpen, setIsPopoverOpen] = useState(false);

  const handleUserKeyPress = (event: any) => {
    if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') {
      setIsPopoverOpen(!isPopoverOpen);
    }
  }

  const firstName = sessionStorage.getItem('Name');
  const lastName = sessionStorage.getItem('lastName');

  const getInitials = () => {
    const initials = (firstName?.[0] || '') + (lastName?.[0] || '');
    return initials.toUpperCase();
  };

  const checkPath = () => {
    if (local.pathname === '/home' || local.pathname === '/') {
      return true
    } else {
      return false
    }
  }

  return (
    <>
      <div className={displayHeadBackgroundImg ? 'safe_area' : 'head_container safe_area'} style={{ backgroundColor: checkPath() ? 'transparent' : '' }}
        id="main-content">
        <div className={(local.pathname === '/home' || local.pathname === '/' || local.pathname === "/login" || local.pathname === "/signup") && !mobile ? '' : 'head_background_img'} style={{ background: checkPath() ? "transparent" : "" }}>
          <div className='head_sub_container'>
            {!isHome && <div style={{ justifyContent: "start", paddingTop: "10px" }} className="logoImgCls">
              <Link to="/" style={{ textDecoration: "none", position: "relative" }}>
                <IonImg src={logo} className={Capacitor.getPlatform() === "ios" ? "logoimgsize_for_ios" : "logoimgsize"}></IonImg>
              </Link>
            </div>}
            <div className="home_head_sub_container2">
              {/* {token !== null && */}
              <div className="head_content_container">
                <NavLink to="/home" className="text_decor">
                  <span className={local.pathname === '/home' ? "font_sign_up_active" : "font_sign_up"}>Home</span>
                </NavLink>
                <NavLink to="/district" className="text_decor">
                  <span className={local.pathname === '/district' ? "font_sign_up_active" : "font_sign_up"}>Information</span>
                </NavLink>
                <NavLink to="/temples" className="text_decor">
                  <span className={local.pathname === '/temples' ? "font_sign_up_active" : "font_sign_up"}>Temples</span>
                </NavLink>
                {userdata !== "ROLE_USER" && userdata !== null && (< NavLink to="/deity" className="text_decor">
                  <span className={local.pathname === '/deity' ? "font_sign_up_active" : "font_sign_up"}>Deities</span>
                </NavLink>)}
                <NavLink to="/offerings" className="text_decor">
                  <span className={local.pathname === '/offerings' ? "font_sign_up_active" : "font_sign_up"}>Offer Pooja</span>
                </NavLink>
                <NavLink to="/localMarket" className="text_decor">
                  <span className={local.pathname === '/localMarket' ? "font_sign_up_active" : "font_sign_up"}>Local Market</span>
                </NavLink>
                {userdata === "ROLE_ADMIN" && (
                  <NavLink to="/admin_page" className="text_decor">
                    <span className={local.pathname === '/admin_page' ? "font_sign_up_active" : "font_sign_up"}>Admin</span>
                  </NavLink>
                )}
                {userdata === "ROLE_VENDOR" && (
                  <div className="volunteer-container">
                    <a href="#!" className="text_decor" onClick={handleVolunteerClick}>
                      <span className={local.pathname === '/marketManagement' ? "font_sign_up_active" : "font_sign_up"}>Vendor</span>
                    </a>
                    <div className="submenu">
                      <NavLink to="/marketManagement" className="submenu_item">
                        Market Management
                      </NavLink>
                      {/* Vinayaki */}
                      <NavLink to="/myorders" className="submenu_item">
                        My Orders
                      </NavLink>
                    </div>
                  </div>
                )}
                {userdata === "ROLE_VOLUNTEER" && (
                  <div className="volunteer-container">
                    <a href="#!" className="text_decor" onClick={handleVolunteerClick}>
                      <span className={local.pathname === '/volunteer' ? "font_sign_up_active" : "font_sign_up"}>Volunteer</span>
                    </a>
                    <div className="submenu">

                      <NavLink to="/volunteer" className="submenu_item">
                        Pending Temple Booking
                      </NavLink>
                      <NavLink to="/prasadhamDelivery" className="submenu_item">
                        Prasadham Delivery / Dispatch
                      </NavLink>
                      <NavLink to="/admtemple" className="submenu_item">
                        Temple Management
                      </NavLink>
                      <NavLink to="/fundForVolunteer" className="submenu_item">
                        Fund for Volunteer
                      </NavLink>
                      <NavLink to="/UserBookingOrders" className="submenu_item">
                        Users Booking orders
                      </NavLink>
                      <div
                        onClick={() => window.open(usermanualPdf, "_blank")}
                        className="submenu_item"
                      >
                        User Manual
                      </div>
                    </div>
                  </div>
                )}

                {userdata === "ROLE_FINANCE" && (
                  <div className="volunteer-container">
                    <a href="#!" className="text_decor" onClick={handleVolunteerClick}>
                      <span className={local.pathname === '/volunteer' ? "font_sign_up_active" : "font_sign_up"}>Finance</span>
                    </a>
                    <div className="submenu">
                      <NavLink to="/fundtobedisbursed" className="submenu_item">
                        Fund to be Disbursed
                      </NavLink>
                      <NavLink to="/fundDisbursed" className="submenu_item">
                        Fund Disbursed
                      </NavLink>
                      <NavLink to="/fundrefunds" className="submenu_item">
                        Fund for Refund
                      </NavLink>
                      <NavLink to="/vdc&other" className="submenu_item">
                        VDC & Other Charges
                      </NavLink>
                    </div>
                  </div>
                )}
                {/* {token !== null && */}
                  <NavLink to="/donations" className="text_decor">
                    <span className={local.pathname === '/donations' ? "font_sign_up_active" : "font_sign_up"}>Donations</span>
                  </NavLink>
                <NavLink to="/AboutUs" className="text_decor">
                  <span className={local.pathname === '/AboutUs' ? "font_sign_up_active" : "font_sign_up"}>About</span>
                </NavLink>
              </div>
              {/* } */}
              <div className="show_slide">
                <IonButtons slot="right">
                  <IonMenuButton autoHide={false} disabled={false} className="head_menu_button" />
                </IonButtons>
              </div>
              <div>
                {token === null ?
                  <div style={{ width: "max-content", display: "flex" }}>
                    <NavLink to="/signup" className="text_decor">
                      <span className={local.pathname === '/signup' ? "font_sign_up_active" : "font_sign_up"}>Sign Up</span>
                    </NavLink>
                    <div className="text_decor">
                      <span className="font_sign_up">/</span>
                    </div>
                    <NavLink to="/login" className="text_decor">
                      <span className={local.pathname === '/login' ? "font_sign_up_active" : "font_sign_up"}>Login</span>
                    </NavLink>
                  </div> : <>
                    <div>
                      <div
                        className="menu_css initials-circle"
                        aria-label="Profile"
                        tabIndex={0}
                        id="profileTrigger"
                        onClick={() => setIsPopoverOpen(!isPopoverOpen)}
                        onKeyDown={handleUserKeyPress}
                      >
                        {getInitials()}
                      </div>
                      <IonPopover
                        isOpen={isPopoverOpen}
                        trigger="profileTrigger"
                        event="click"
                        id={'profilePop'}
                        dismissOnSelect={true}
                        show-backdrop={false}
                      >
                        <IonContent className="popover_head">
                          <IonList className="popMenuListCls">
                            <Link to="/profile" className="text_decor">
                              <IonItem
                                className="border_menu"
                                button={true}
                                detail={false}
                              >
                                My Profile
                              </IonItem>
                            </Link>
                            {/* Vinayaki */}
                            {userdata === "ROLE_VOLUNTEER" || userdata === "ROLE_FINANCE" || userdata === "ROLE_ADMIN" || userdata === "ROLE_VENDOR" || userdata === "ROLE_USER"? (
                              <Link to="/orders" className="text_decor">
                                <IonItem
                                  className="border_menu"
                                  button={true}
                                  detail={false}
                                >
                                  My Orders (All)
                                </IonItem>
                              </Link>
                            ) : <></>}
                            {userdata === "ROLE_VOLUNTEER" || userdata === "ROLE_FINANCE" || userdata === "ROLE_ADMIN" || userdata === "ROLE_VENDOR" || userdata === "ROLE_USER"? (
                              <div>
                                {/* <Link to="/myorders" className="text_decor">
                                  <IonItem
                                    className="border_menu"
                                    button={true}
                                    detail={false}
                                  >
                                    My Offerings
                                  </IonItem>
                                </Link>
                                <Link to="/mymaterial" className="text_decor">
                                  <IonItem
                                    className="border_menu"
                                    button={true}
                                    detail={false}
                                  >
                                    My Materials
                                  </IonItem>
                                </Link>
                                */}
                                <Link to="/mycart" className="text_decor">
                                  <IonItem
                                    className="border_menu"
                                    button={true}
                                    detail={false}
                                  >
                                    My Cart
                                  </IonItem>
                                </Link>
                                {/* <Link to="/mydonation" className="text_decor">
                                  <IonItem
                                    className="border_menu"
                                    button={true}
                                    detail={false}
                                  >
                                    My Donation
                                  </IonItem>
                                </Link> */}
                                {/* <Link to="/myprojectdonation" className="text_decor">
                                  <IonItem
                                    className="border_menu"
                                    button={true}
                                    detail={false}
                                  >
                                    My Project Donation
                                  </IonItem>
                                </Link> */}
                              </div>
                            ) : (<div></div>)}
                            <Link to="/change_password" className="text_decor">
                              <IonItem
                                className="border_menu"
                                button={true}
                                detail={false}
                              >
                                Change Password
                              </IonItem>
                            </Link>
                            <IonItem
                              className="border_menu"
                              button={true}
                              detail={false}
                              onClick={(e) => setModalopen(true)}
                              id="logouts-modal"
                            >
                              Sign Out
                            </IonItem>
                          </IonList>
                        </IonContent>
                      </IonPopover>
                      <Modal show={modalopen} className="modal_dialog_width1 logout-modal">
                        <Modal.Body>
                          <IonRow>
                            <IonCol style={{ textAlign: "center" }}>
                              <h5 className="mt-2">Do you want to sign out ?</h5>
                            </IonCol>
                          </IonRow>
                          <IonRow className="mt-12">
                            <IonCol size="6" style={{ textAlign: "end" }}>
                              <IonButton onClick={logout}><span className="button_padding">Yes</span></IonButton>
                            </IonCol>
                            <IonCol size="6">
                              <IonButton onClick={(e) => setModalopen(false)}><span className="button_padding">No</span></IonButton>
                            </IonCol>
                          </IonRow>
                        </Modal.Body>
                      </Modal>
                    </div>
                  </>}
              </div>
            </div>
          </div>

          {mobile ? <>
            <div className="head_text_container">
              <IonText className="head_middle_text">{pageName}</IonText>
            </div>
          </> : <>
            {local.pathname != "/home" && local.pathname != "/" && local.pathname != "" && local.pathname != "/signup" && local.pathname != "/login" ?
              <div className="head_text_container">
                <IonText className="head_middle_text">{pageName}</IonText>
              </div>
              : <></>}</>}

          {/* {local.pathname != "/home" && local.pathname != "/" && local.pathname != "" ?
            <div className="head_bubble_container">
              <div className="head_bubble">
                {commanName && (
                  <Link to="/home" style={{ textDecoration: "none" }}>
                    <IonText className="head_bubble_inside_comman_text">{commanName}</IonText>
                  </Link>
                )}
                {commanName && pageName && (
                  <IonText className="head_bubble_inside_comman_text"> / </IonText>
                )}
                {pageName && (
                  <IonText className="head_bubble_inside_page_text">{pageName}</IonText>
                )}
              </div>
            </div>
            : <></>} */}
        </div>
      </div >
      {mobile ? <IonMenu content-id="main-content" id="menu_id" >
        <IonHeader>
          <IonToolbar className="Side_Menu_Head">
            <IonTitle>Atmagram</IonTitle>
          </IonToolbar>
        </IonHeader>

        <IonContent>
          <IonList>
            <div>
              {(userdata === "ROLE_USER" || !userdata || userdata === "ROLE_VOLUNTEER" || userdata === "ROLE_FINANCE" || userdata == "ROLE_ADMIN" || userdata == "ROLE_VENDOR") ? (
                // <IonMenuToggle auto-hide="true">
                <IonList>


                  <Link to="/home" className='link_cls'>
                    <IonItem>
                      <span>
                        Home
                      </span>
                    </IonItem>
                  </Link>
                  <Link to="/district" className='link_cls'>
                    <IonItem>
                      <span>
                        Information
                      </span>
                    </IonItem>
                  </Link>
                  <Link to="/temples" className='link_cls'>
                    <IonItem>
                      <span>
                        Temples
                      </span>
                    </IonItem>
                  </Link>
                  {userdata !== "ROLE_USER" && userdata !== null && <Link to="/deity" className='link_cls'>
                    <IonItem>
                      <span>
                        Deities
                      </span>
                    </IonItem>
                  </Link>
                  }
                  <Link to="/offerings" className='link_cls'>
                    <IonItem>
                      <span>
                        Offer Pooja
                      </span></IonItem>
                  </Link>

                  <Link to="/localMarket" className='link_cls'>
                    <IonItem>
                      <span>
                        Local Market
                      </span>
                    </IonItem>
                  </Link>
                  {(userdata === "ROLE_VOLUNTEER") &&
                    <>
                      {/* Parent Item */}
                      <IonItem button onClick={toggleSubmenu}>
                        <span>Volunteer</span>
                        <IonIcon
                          slot="end"
                          icon={showSubmenu ? chevronDownOutline : chevronForwardOutline}
                        />
                      </IonItem>

                      {/* Submenu Items */}
                      {showSubmenu && (
                        <div style={{ paddingLeft: '16px' }}>
                          <Link to="/volunteer" className='link_cls'>
                            <IonItem>
                              <span>Pending Temple Booking</span>
                            </IonItem>
                          </Link>

                          <Link to="/prasadhamDelivery" className='link_cls'>
                            <IonItem>
                              <span>Prasadham Delivery</span>
                            </IonItem>
                          </Link>

                          <Link to="/fundForVolunteer" className='link_cls'>
                            <IonItem>
                              <span>Fund for Volunteer</span>
                            </IonItem>
                          </Link>

                          <Link to="/UserBookingOrders" className='link_cls'>
                            <IonItem>
                              <span>User Booking Orders</span>
                            </IonItem>
                          </Link>

                          <Link to="/admtemple" className='link_cls'>
                            <IonItem>
                              <span>Temple Management</span>
                            </IonItem>
                          </Link>
                        </div>
                      )}
                    </>
                  }
                  {(userdata === "ROLE_ADMIN") &&
                    <>
                      <Link to="/admin_page" className='link_cls'>
                        <IonItem>
                          <span>
                            Admin
                          </span>
                        </IonItem>
                      </Link>
                    </>
                  }
                  {(userdata === "ROLE_VENDOR") &&
                    <>
                      <Link to="/marketManagement" className='link_cls'>
                        <IonItem>
                          <span>
                            Vendor
                          </span>
                        </IonItem>
                      </Link>
                    </>
                  }
                  {(userdata === "ROLE_FINANCE") &&
                    <>
                      <Link to="/fundtobedisbursed" className='link_cls'>
                        <IonItem>
                          <span>
                            Fund to be Disbursed
                          </span>
                        </IonItem>
                      </Link>
                      <Link to="/fundDisbursed" className='link_cls'>
                        <IonItem>
                          <span>
                            Fund Disbursed
                          </span>
                        </IonItem>
                      </Link>
                      <Link to="/fundrefunds" className='link_cls'>
                        <IonItem>
                          <span>
                            Fund for Refund
                          </span>
                        </IonItem>
                      </Link>
                      <Link to="/vdc&other" className='link_cls'>
                        <IonItem>
                          <span>
                            VDC & Other Charges
                          </span>
                        </IonItem>
                      </Link>
                    </>
                  }
                  {/* {uFlag === 'true' &&
                    <Link to="/" className='link_cls'>
                      <IonItem>
                        <span>
                          Supervisor
                        </span>
                      </IonItem>
                    </Link>
                  } */}
                  {/* {uFlag === 'true' &&
                    <Link to="/" className='link_cls'>
                      <IonItem>
                        <span>
                          Admin
                        </span>
                      </IonItem>
                    </Link>
                  } */}
                  {/* <Link to="/" className='link_cls'>
                    <IonItem>
                      <span>
                        About
                      </span>
                    </IonItem>
                  </Link> */}
                  {/* {uFlag === 'true' &&
                    <Link to="/materials" className='link_cls'>
                      <IonItem>
                        <span>
                          Pooja Materials
                        </span>
                      </IonItem>
                    </Link>
                  } */}
                  {/* {uFlag === 'true' &&
                    <Link to="/grammerce" className='link_cls'>
                      <IonItem>
                        <span>
                          Grammerce
                        </span>
                      </IonItem>
                    </Link>
                  } */}
                  <Link to="/donations" className='link_cls'>
                    <IonItem>
                      <span>
                        Donations
                      </span>
                    </IonItem>
                  </Link>
                  {/* {uFlag === 'true' &&

                    <Link to="/project" className='link_cls'>
                      <IonItem>
                        <span>
                          Projects
                        </span>
                      </IonItem>
                    </Link>

                  } */}
                </IonList>
                // </IonMenuToggle>

              ) : (
                <div>
                  {userdata === "ROLE_ADMIN" && uFlag === 'true' ? (
                    <div>
                      {/* <IonMenuToggle auto-hide="true"> */}
                      <IonList>
                        <Link to='admin_page' className='link_cls'>
                          <IonItem>
                            <span>
                              User Management
                            </span>
                          </IonItem>
                        </Link>

                        <Link to="/deitymanagement" className='link_cls'>
                          <IonItem>
                            <span>
                              Deity Management
                            </span>
                          </IonItem>
                        </Link>

                        <Link to="/districtmanagement" className='link_cls'>
                          <IonItem>
                            <span>
                              District Management
                            </span>
                          </IonItem>
                        </Link>
                        <Link to="/admtemple" className='link_cls'>
                          <IonItem>
                            <span>
                              Temple Management
                            </span>
                          </IonItem>
                        </Link>
                        <Link to="/volunteer" className='link_cls'>
                          <IonItem>
                            <span>
                              Temple Booking Management
                            </span>
                          </IonItem>
                        </Link>
                        <Link to="/offeringsmanagement" className='link_cls'>
                          <IonItem>
                            <span>
                              Pooja Master
                            </span>
                          </IonItem>
                        </Link>
                        <Link to="/marketManagement" className='link_cls'>
                          <IonItem>
                            <span>
                              Market Management
                            </span>
                          </IonItem>
                        </Link>
                      </IonList>
                      <IonList>
                        <Link to="/donationmanage" className='link_cls'>
                          <IonItem>
                            <span>
                              Donation Management
                            </span>
                          </IonItem>
                        </Link>
                      </IonList>
                      <IonItem
                        button
                        onClick={() => {
                          setIsGraisible(true);
                          if (isGraVisible === true) {
                            setIsGraisible(false);
                          }
                        }}>
                        <IonLabel>Configure</IonLabel>
                        <IonIcon
                          slot="end"
                          icon={isGraVisible ? arrowDown : arrowForward}
                        ></IonIcon>
                      </IonItem>
                      <IonList>
                        <Link to="/carousel" className='link_cls' hidden={!isGraVisible}>
                          <IonItem
                            button>
                            <span >
                              Carousel Management
                            </span>
                          </IonItem>
                        </Link>
                      </IonList>
                      <IonItem
                        button
                        onClick={() => {
                          setIsProjisible(true);
                          if (isProjVisible === true) {
                            setIsProjisible(false);
                          }
                        }}>
                        <IonLabel>Report</IonLabel>
                        <IonIcon
                          slot="end"
                          icon={isProjVisible ? arrowDown : arrowForward}
                        ></IonIcon>
                      </IonItem>
                      <IonList>
                        <Link to="/fundtobedisbursed" className='link_cls' hidden={!isProjVisible}>
                          <IonItem
                            button>
                            <span >
                              Fund To be Disbursed
                            </span>
                          </IonItem>
                        </Link>
                        <Link to="/funddisbursed" className='link_cls' hidden={!isProjVisible}>
                          <IonItem
                            button>
                            <span >
                              Fund Disbursed
                            </span>
                          </IonItem>
                        </Link>
                        <Link to="/fundrefunds" className='link_cls' hidden={!isProjVisible}>
                          <IonItem
                            button>
                            <span >
                              Fund for Refund
                            </span>
                          </IonItem>
                        </Link>
                        <Link to="/prasadhamDelivery" className='link_cls' hidden={!isProjVisible}>
                          <IonItem
                            button>
                            <span >
                              Prasadham to be Delivered
                            </span>
                          </IonItem>
                        </Link>
                        <Link to="/reviewList" className='link_cls' hidden={!isProjVisible}>
                          <IonItem
                            button>
                            <span >
                              Review
                            </span>
                          </IonItem>
                        </Link>
                      </IonList>
                    </div>

                  ) : userdata === "ROLE_TEMPADMIN" && uFlag === 'true' ? (
                    // <IonMenuToggle auto-hide="false">
                    <IonList>
                      <Link to='tempadmin' className='link_cls'>
                        <IonItem>
                          <span>
                            Temple Management
                          </span> </IonItem>
                      </Link>
                      <Link to='tempadmin' className='link_cls'>
                        <IonItem>
                          <span>
                            Pooja Offerings
                          </span> </IonItem>
                      </Link>

                      <Link to="/order" className='link_cls'>
                        <IonItem>
                          <span>
                            Order Management
                          </span></IonItem>
                      </Link>

                      <Link to="/reports" className='link_cls'>
                        <IonItem>
                          <span>
                            Report
                          </span>
                        </IonItem>
                      </Link>
                    </IonList>
                    // </IonMenuToggle>



                  ) : userdata === "ROLE_VENDOR" && uFlag === 'true' ? (
                    // <IonMenuToggle auto-hide="false">
                    <IonList>


                      {/* Vinayaki */}
                      <Link to='/marketManagement' className='link_cls'>
                        <IonItem>
                          <span>
                            Material Management
                          </span> </IonItem>
                      </Link>

                      {/* <Link to="/vendormateriaorders" className='link_cls'>
                        <IonItem>
                          <span>
                            Material Order Management
                          </span> </IonItem>
                      </Link>

                      <Link to="/reports" className='link_cls'>
                        <IonItem>
                          <span>
                            Report
                          </span>
                        </IonItem>
                      </Link> */}
                    </IonList>
                    // </IonMenuToggle>


                  ) : userdata === "ROLE_PROJECTADMIN" && uFlag === 'true' ? (
                    // <IonMenuToggle auto-hide="false">
                    <IonList>

                      <Link to="/projectadmin" className='link_cls'>
                        <IonItem>
                          <span>
                            Project Management
                          </span> </IonItem>
                      </Link>

                      <Link to="/projectdonate" className='link_cls'>
                        <IonItem>
                          <span>
                            Project Donation
                          </span> </IonItem>
                      </Link>

                      <Link to="/reports" className='link_cls'>
                        <IonItem>
                          <span>
                            Report
                          </span>
                        </IonItem>
                      </Link>
                    </IonList>
                    // </IonMenuToggle>


                  ) : <div>{Capacitor.getPlatform() === "web" ?
                    // <IonMenuToggle auto-hide="false">
                    <IonList lines="none">

                      <Link to="/" className='link_cls'>
                        <IonItem>
                          <span>
                            Home
                          </span></IonItem>
                      </Link>

                      <Link to="/temples" className='link_cls'>
                        <IonItem>
                          <span>
                            Temples
                          </span></IonItem>
                      </Link>

                      <Link to="/offerings" className='link_cls'>
                        <IonItem>
                          <span >
                            Offer Pooja
                          </span></IonItem>
                      </Link>

                      <Link to="/materials" className='link_cls'>
                        <IonItem>
                          <span>
                            Pooja Materials
                          </span></IonItem>
                      </Link>

                      <Link to="/grammerce" className='link_cls'>
                        <IonItem>
                          <span >
                            Grammerce
                          </span></IonItem>
                      </Link>
z
                      <Link to="/donations" className='link_cls'>
                        <IonItem>
                          <span>
                            Donations
                          </span></IonItem>
                      </Link>



                      <Link to="/project" className='link_cls'>
                        <IonItem>
                          <span>
                            Projects
                          </span></IonItem>
                      </Link>

                    </IonList>

                    // </IonMenuToggle> 
                    : <></>}</div>}
                </div>
              )}


            </div>


          </IonList >
        </IonContent >
      </IonMenu > : <></>
      }
    </>
  );
};
export default HeadFoot;